(() => {
  const initialize = (root) => {
    if (root.dataset.campaignReady) return;
    const buttons = [...root.querySelectorAll('[data-campaign-thumb]')];
    const stage = root.querySelector('[data-campaign-stage]');
    const title = root.querySelector('[data-gallery-title]');
    const price = root.querySelector('[data-gallery-price]');
    const count = root.querySelector('[data-campaign-count]');
    const status = root.querySelector('[data-campaign-status]');
    if (!stage || !title || !price || !buttons.length) return;
    root.dataset.campaignReady = 'true';
    let request = 0;

    const select = async (button) => {
      const ticket = ++request;
      if (button.getAttribute('aria-pressed') === 'true') {
        stage.removeAttribute('aria-busy');
        status.textContent = '';
        return;
      }
      stage.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading product image.';
      const next = new Image();
      next.alt = button.dataset.alt;
      next.width = Number(button.dataset.width);
      next.height = Number(button.dataset.height);
      next.decoding = 'async';
      next.dataset.campaignMain = '';
      next.dataset.productId = button.dataset.productId;
      next.dataset.imageId = button.dataset.imageId;
      try {
        await new Promise((resolve, reject) => {
          next.onload = resolve;
          next.onerror = () => reject(new Error('Product image unavailable'));
          next.sizes = button.dataset.sizes;
          next.srcset = button.dataset.srcset;
          next.src = button.dataset.src;
        });
        if (next.decode) await next.decode();
        if (!next.naturalWidth) throw new Error('Product image unavailable');
        if (ticket !== request || !root.isConnected) return;
        // One synchronous commit after decode: media, metadata and native destination always agree.
        stage.replaceChildren(next);
        stage.href = button.dataset.url;
        stage.dataset.productId = button.dataset.productId;
        stage.dataset.variantId = button.dataset.variantId;
        stage.setAttribute('aria-label', `View ${button.dataset.title} — ${button.dataset.price}`);
        title.textContent = button.dataset.title;
        price.textContent = button.dataset.price;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        const position = buttons.indexOf(button) + 1;
        count.textContent = `${position} / ${buttons.length}`;
        status.textContent = `Product ${position} of ${buttons.length}. ${button.dataset.title}. ${button.dataset.price}.`;
      } catch (_) {
        if (ticket === request) status.textContent = 'This product image could not load. Please try again; the previous product is still displayed.';
      } finally {
        next.onload = null;
        next.onerror = null;
        if (ticket === request) stage.removeAttribute('aria-busy');
      }
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(button));
      button.addEventListener('keydown', (event) => {
        const destinations = {
          ArrowRight: (index + 1) % buttons.length,
          ArrowDown: (index + 1) % buttons.length,
          ArrowLeft: (index - 1 + buttons.length) % buttons.length,
          ArrowUp: (index - 1 + buttons.length) % buttons.length,
          Home: 0,
          End: buttons.length - 1,
        };
        if (!(event.key in destinations) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        const target = buttons[destinations[event.key]];
        target.focus({ preventScroll: true });
        select(target);
      });
    });
  };
  const scan = (scope) => scope.querySelectorAll('[data-campaign-gallery]').forEach(initialize);
  scan(document);
  if (!window.ydCampaignGalleryEditorBound) {
    window.ydCampaignGalleryEditorBound = true;
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  }
})();
